export default "| **N-7** | Decided: Stakeholder Pulse is no exception, on like every module, and an admin switches it off | #1374 | Nov 1 |"